import { appTheme } from '../shared/theme';

/** Horizontal padding for subscription premium screens. */
export const SUBSCRIPTION_SCREEN_PADDING_H = appTheme.spacing.md;

/** Space between the header row and the first scroll item. */
export const SUBSCRIPTION_SCREEN_GAP_BELOW_HEADER = appTheme.spacing.md;

/**
 * `paddingTop` for main `ScrollView` `contentContainerStyle` when using `ScreenHeader` + `useHeaderTopPadding()`.
 */
export function getSubscriptionScrollPaddingTop(header_top: number): number {
  return header_top + SUBSCRIPTION_SCREEN_GAP_BELOW_HEADER;
}

/** Extra scroll space when the fixed checkout bar is shown. */
export const SUBSCRIPTION_SCREEN_BOTTOM_BAR_CLEARANCE = 132;

/** Bottom padding when there is no fixed footer (empty lists). */
export const SUBSCRIPTION_SCREEN_SCROLL_BOTTOM_EMPTY = appTheme.spacing.xl;
